import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import logo from '../../../assets/images/ceba-logo-white-text.png'
import {
  Typography,
  Paper,
  Tooltip
} from '@material-ui/core'
import checkMailGraphic from '../images/check_mail_graphic.png'

const useStyles = makeStyles((theme) => ({
  content: {
    textAlign: 'center',
    padding: '40px 10px'
  },
  header: {
    backgroundColor: '#445765',
    padding: '10px 0 10px 10px'
  },
  logo: {
    maxHeight: '80px',
    height: '12vw'
  },
  icon: {
    marginBottom: '40px'
  },
  hint: {
    color: 'lightgray'
  },
  emailGraphic: {
    width: '100%',
    maxWidth: '600px'
  }
}))

const RegistrationSubmitted = ({
  userName,
  userEmail
}) => {
  const classes = useStyles()

  return(
    <Paper elevation={3} className={classes.container}>
      <div className={classes.header}>
        <img src={logo} className={classes.logo}/>
      </div>
      <div className={classes.content}>
        <Typography variant='h4' gutterBottom>
          Thanks for joining us, {userName}!
        </Typography>

        <Typography variant='h5' gutterBottom>
          Check your email to verify your account.
        </Typography>

        <div className={classes.icon}>
          <img className={classes.emailGraphic} src={checkMailGraphic} alt="check your email"/>
        </div>

        <Typography variant='subtitle1' gutterBottom>
          You will receive an email from us at <strong>{userEmail}</strong> within a few minutes.
        </Typography>

        <Typography variant='subtitle1' gutterBottom>
          Open it up and click the button to verify your account.
        </Typography>

        <Typography variant='subtitle1'>
          TIP: To find this email quickly, search your email (all folders) for the phrase "registration confirmation".
        </Typography>
        </div>
    </Paper>
  )
}

export default RegistrationSubmitted
